import { render, staticRenderFns } from "./menuTile.vue?vue&type=template&id=6f350c45&scoped=true"
import script from "./menuTile.vue?vue&type=script&lang=js"
export * from "./menuTile.vue?vue&type=script&lang=js"
import style0 from "./menuTile.vue?vue&type=style&index=0&id=6f350c45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f350c45",
  null
  
)

export default component.exports